import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import CryptoJS from "crypto-js";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButtons/Button.jsx";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import Select from "react-select";
import axios from "axios";
import LoadingOverlay from "react-loading-overlay";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import moment from "moment";
import { getClientIdNameMap } from "../../util/clients/getClientIdNameMap";

const fileUploadUrl = "https://cto4ooc34663xujazvnrvihm6u0kaxih.lambda-url.us-west-2.on.aws/uploadFile"

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      error: false,
      file: "",
      fileName: "",
      fileType: "",
      formModal: false,
      localStorageClientId: "",
      clientName: "",
      fileUploadStatus: false,
      fileTypesDropdown: [
        {
          value: "geo_file",
          label: "Geo File",
        },
        // {
        //   value: "seed_list",
        //   label: "Seed List",
        // },
        {
          value: "suppression_list",
          label: "Suppression List",
        },
      ],
      programTypesDropdown: [
        {
          value: "preclub",
          label: "Guest Connect",
        },
        {
          value: "eclub",
          label: "Eclub",
        },
        {
          value: "loyalty",
          label: "Loyalty",
        },
        {
          value: "display",
          label: "Display",
        },
      ],
      selectedFileType: "",
      selectedProgramType: "",
      seedListDeployStatus: false,
      fileUploadStatusColor: "success",
      fileUploadStatusMessage: "",
      fileUploadSuccessStatus: false,
      isSuppressionSelected: false,
    };
  }

  async componentDidMount() {
    let localStorageClientId = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("clientId"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
    // Client id -> name map is scanned from the cmp-v2-clients dynamo table
    // (via the /clients API) instead of being hardcoded here.
    let cmpClientIdObject = await getClientIdNameMap();
    this.setState({
      localStorageClientId: localStorageClientId,
      clientName: cmpClientIdObject[localStorageClientId],
    });
  }

  handleErrorTag(errorString, toChangeStatus) {
    this.setState({ fileUploadStatusMessage: errorString }, () => {
      setTimeout(
        function () {
          this.setState({
            fileUploadStatusMessage: "",
          });
          if(toChangeStatus) {
            this.setState({
              fileUploadSuccessStatus: false,
            });
            window.location.reload();
          }
        }.bind(this),
        3000
      );
    });
  }

  handleFileTypeChange = (event) => {
    this.setState({ selectedFileType: event }, () => {
      if (this.state.selectedFileType.value === "suppression_list") {
        this.setState({ isSuppressionSelected: true });
      } else {
        this.setState({ isSuppressionSelected: false });
      }
    });
  };

  handleProgramTypeChange = (event) => {
    this.setState({ selectedProgramType: event });
  };

  getFileUploadedDate = () => {
    let now = new Date();
    let dateString = moment(now).format("YYYYMMDD");
    return dateString;
  };

  saveFile = (e) => {
    this.setState({ file: e.target.files[0] });

    let selectedFileName = e.target.files[0].name;
    let splittedFileName = selectedFileName.split(".");

    let selectedFileExtension = splittedFileName.pop();

    if (this.state.selectedFileType.value === "geo_file") {
      const dateValue = this.getFileUploadedDate();

      // let selectedFileName = e.target.files[0].name;
      // let splittedFileName = selectedFileName.split(".");

      // let selectedFileExtension = splittedFileName.pop();
      let joinedFileName = splittedFileName.join(".");
      let completeFileName =
        // joinedFileName + "_" + dateValue + "." + selectedFileExtension;
        this.state.clientName +
        "_geo" +
        "_" +
        dateValue +
        "." +
        selectedFileExtension;

      this.setState({ fileName: completeFileName });
    } else if (this.state.selectedFileType.value === "seed_list") {
      this.setState({
        fileName:
          this.state.clientName + "_seedlist" + "." + selectedFileExtension,
      });
    } else if (this.state.selectedFileType.value === "suppression_list") {
      this.setState({
        fileName:
          this.state.clientName + "_suppression" + "." + selectedFileExtension,
      });
    }
  };

  uploadFile = async (e) => {
    if (this.state.selectedFileType === null || this.state.selectedFileType.value === "") {
      this.handleErrorTag("Please select a file type", false);
      return
    }
    if(this.state.selectedFileType.value === "suppression_list" && (this.state.selectedProgramType === null || this.state.selectedProgramType.value === "")) {
      this.handleErrorTag("Please select a program type", false);
      return
    }
    if (this.state.file === null || this.state.file === "") {
      this.handleErrorTag("Please select a file to upload", false);
      return;
    }
    this.setState({
      fileUploadStatus: true,
    });
    const formData = new FormData();
    formData.append("file", this.state.file);
    formData.append("fileName", this.state.fileName);
    formData.append("clientName", this.state.clientName);
    formData.append("fileType", this.state.selectedFileType.value);
    formData.append("programName", this.state.selectedProgramType.value);

    try {
      const response = await axios.post(
        fileUploadUrl,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log(response);
      this.setState(
        {
          fileUploadStatus: false,
          fileUploadStatusMessage: "File uploaded successfully",
          fileUploadSuccessStatus: true,
          file: "",
          fileName: "",
          selectedFileType: "",
        },
        () => {
          setTimeout(
            function () {
              this.setState({
                fileUploadSuccessStatus: false,
              });
              window.location.reload();
            }.bind(this),
            3000
          );
        }
      );
    } catch (error) {
      const errorResponse = error.response;
      console.log(errorResponse.data.message);
      this.setState({
        fileUploadStatus: false,
        fileUploadSuccessStatus: true,
        fileUploadStatusColor: "danger",
        file: "",
        fileName: "",
        selectedFileType: "",
      });
      if (errorResponse.data.message === "File is empty") {
        this.handleErrorTag("The file is empty", true);
      } else if (errorResponse.data.message === "Headers do not match") {
        this.handleErrorTag("Headers do not match", true);
      } else {
        this.handleErrorTag("There was an error uploading the file", true);
      }
      console.log(error.response);
    }
  };
  render() {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12} xl={12}>
          <Snackbar
            place="td"
            color={this.state.fileUploadStatusColor}
            message={this.state.fileUploadStatusMessage}
            open={this.state.fileUploadSuccessStatus}
            closeNotification={() =>
              this.setState({ fileUploadSuccessStatus: false })
            }
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <LoadingOverlay
            active={this.state.fileUploadStatus}
            spinner
            text="Uploading File"
          >
            <Card>
              <CardBody>
                <form>
                  <center>
                    <h3>Upload File</h3>
                  </center>
                  <br />
                  <React.Fragment>
                    <span>
                      Please select the type of file you want to upload
                    </span>
                    <br />
                    <div style={{ marginTop: "10px" }}>
                      <Select
                        isDisabled={false}
                        onChange={this.handleFileTypeChange}
                        value={this.state.selectedFileType}
                        options={this.state.fileTypesDropdown}
                        isMulti={false}
                      />
                    </div>
                    {this.state.isSuppressionSelected === true ? <br /> : null}
                    {this.state.isSuppressionSelected && (
                      <div>
                        <span>Please select the program type</span>
                        <br />
                        <div style={{ marginTop: "10px" }}>
                          <Select
                            isDisabled={false}
                            onChange={this.handleProgramTypeChange}
                            value={this.state.selectedProgramType}
                            options={this.state.programTypesDropdown}
                            isMulti={false}
                          />
                        </div>
                      </div>
                    )}
                    <CustomInput
                      id="listDescription"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      disableUnderline={true}
                      inputProps={{
                        onChange: (event) => this.saveFile(event),
                        type: "file",
                        inputProps: {
                          accept: ".csv",
                        },
                        disableUnderline: true,
                      }}
                    />
                    {/* ERROR TAG */}
                    <span className="redColor">
                      {this.state.fileUploadStatusMessage}
                    </span>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        onClick={() => {
                          this.uploadFile();
                        }}
                        className="btn btncreate"
                        color="secondary"
                      >
                        Upload
                      </Button>
                    </div>
                  </React.Fragment>
                </form>
              </CardBody>
            </Card>
          </LoadingOverlay>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(notificationsStyle)(FileUpload);


// WEBPACK FOOTER //
// ./src/views/FileUpload/FileUpload.jsx